/**
 * Имена UXFB-событий должны побайтово совпадать с кампаниями в админке UX Feedback.
 */

/** Клик «Сообщить об ошибке» в модалке AI-сравнения ЖК, десктоп. */
export const UXFB_EVENT_AI_COMPARISON_REPORT_ERROR_DESKTOP = 'newbuilding_ai_comparison_uxfeedback_desktop';

/** Клик «Сообщить об ошибке» в модалке AI-сравнения ЖК, mweb. */
export const UXFB_EVENT_AI_COMPARISON_REPORT_ERROR_MWEB = 'newbuilding_ai_comparison_uxfeedback_mweb';

/** Заход на страницу сравнения ЖК (десктоп и mweb, платформа — в атрибуте `platform`). */
export const UXFB_EVENT_COMPARE_ZHK = 'compare_zhk';
